// extracted by mini-css-extract-plugin
module.exports = {"header":"_73ecee83"};